// Skills Icons
import htmlIcon from "./images/html.svg"
import cssIcon from "./images/css.svg"
import reactIcon from "./images/react.svg"
import jsIcon from "./images/javascript.svg"
import designIcon from "./images/design.svg"
import reduxIcon from "./images/redux.svg"

import firebaseIcon from "./images/firebase.svg"
import sqlIcon from "./images/sql.svg"
import nodeIcon from "./images/node.svg"
import mongoIcon from "./images/mongodb.svg"
import graphqlIcon from "./images/graphql.svg"
import bootstrapIcon from "./images/bootstrap.svg"
import CVIcon from "./images/cv.svg"

import postgresIcon from "./images/postgresql.svg"
import redisIcon from "./images/redis.svg"
import nextjsIcon from "./images/nextjs.svg"
import openaiIcon from "./images/openai.svg"
import awsIcon from "./images/aws.svg"
import gcpIcon from "./images/gcp.svg"

// Social Icon
import githubIcon from "./images/github.svg"
import codepenIcon from "./images/codepen.svg"
import dribbbleIcon from "./images/dribbble.svg"
import instagramIcon from "./images/instagram.svg"

export default {
    // (Please Do Not Remove The comma(,) after every variable)
    // Change The Website Template\

    tabs: [
        "Mobile Apps", "Web Apps", "Blockchain"
    ],

    // Header Details ---------------------
    name: "Muhammad Salman Hafeez",
headerTagline: [
        // Line 1 For Header
        "Architecting Scalable",
        // Line 2 For Header
        "Data-Driven",
        // Line 3 For Header
        "Advanced MERN/PERN Stack",
        " & AI Applications.",
    ],
    // Header Paragraph
headerParagraph: "Want to scale your platform? Let's optimize performance, reduce latency, and ensure 99.9% uptime. I engineer advanced MERN systems and intelligent AI workflows that automate manual tasks, accelerate data processing, and deliver elite enterprise solutions.",
    // Contact Email
    contactEmail: "maansallu786@gmail.com",
    // Contact Phone
    contactPhone: "+923174346353",

    // End Header Details -----------------------

    // Work Section ------------------------
    mobileProjects: [
        {
            title: "Vachwa App", // Project Title - Add Your Project Title Here
            para: "An app to facilitate employer to post jobs and for employees to get a number of jobs to submit application.",
            // Add Your Service Type Here
            // Project Image - Add Your Project Image Here
            imageSrc: "https://play-lh.googleusercontent.com/Lrv_w9ES5HNHllxlsnmKEoqpXcAXxfvdxYcCFVfv7AbctSmc8jgBIXqfYnPp0aWXNm8=w480-h960-rw",
            technology: "React Native,Firebase",
            // Project URL - Add Your Project Url Here
            url: ["https://play.google.com/store/apps/details?id=com.app.vachwa&pli=1", "https://play.google.com/store/apps/details?id=com.app.vachwa&hl=en&gl=US"]
        }, {
            title: "Petluvs App", // Project Title - Add Your Project Title Here
            para: "Create pet playdates, find pet hotspots near you. Share your pet's social media. Find local veterinarians, pet services, pet friendly restaurants & hotels, boarding, day care.",
            // Add Your Service Type Here
            // Project Image - Add Your Project Image Here
            imageSrc: "https://play-lh.googleusercontent.com/4b0x6TzoS-tXX_J3YmB93tt01CUEZfNEHk6UKMTkoltuxbQvtz_akYc0hTV6B9jsug=w480-h960-rw",
            // Project URL - Add Your Project Url Here
            url: [
                "https://play.google.com/store/apps/details?id=com.app.petluvs&hl=en&gl=US", "https://apps.apple.com/us/app/petluvs/id1543761341"
            ],
            technology: "React Native,Firebase"
        }, {
            title: "Reilu Food", // Project Title - Add Your Project Title Here
            para: "Food Delivery Application.You can order food via our app and enjoy the meal.",
            // Add Your Service Type Here
            // Project Image - Add Your Project Image Here
            imageSrc: "https://is3-ssl.mzstatic.com/image/thumb/Purple122/v4/de/84/1d/de841de5-6f85-9727-2d8a-f421533a8d04/AppIcon-1x_U007emarketing-0-10-0-85-220.png/230x0w.webp",
            // Project URL - Add Your Project Url Here
            url: [
                "https://play.google.com/store/apps/details?id=com.DeliviGo.delivigocustomerapp&hl=en&gl=US", "https://apps.apple.com/pk/app/delivigo/id1483597029"
            ],
            technology: "React Native,Firebase"

        }
    ],
    webProjects: [
        {
            title: 'Gourmet Career Portal',
            para: 'A centralized platform for talent acquisition and recruitment management, streamlining the hiring process for Gourmet Pakistan.',
            imageSrc: "https://i.ibb.co/ynYQHw1V/chrome-capture.png", // Attempting a standard direct link format or using what they gave
            url: ['https://careers.gourmetpakistan.com'],
            technology: "NextJs, React, PostgreSQL"
        },
        {
            title: 'Real Estate Web Application',
            para: 'Complete Mern Stack Based Application',
            imageSrc: "https://i.ibb.co/RTWVcsSp/chrome-capture-2026-1-10.png",
            url: ['https://samras-real-estate-app.netlify.app/'],
            technology: "ReactJs,NodeJs,MongoDB,Express"
        },
        // {
        //     title: 'Lobium AI',
        //     para: 'Lobium AI is a platform designed to revolutionize public affairs through advanced AI and machine learning tools.',
        //     imageSrc: "https://cdn.prod.website-files.com/66a07e65e37503b81a7605a1/66a07e65e37503b81a7605fc_Tim%20Lobium%20Group.svg",
        //     url: ['https://lobium.ai/'],
        //     technology: "ReactJs,NextJs"
        // },
        // {
        //     title: 'CrowdExotic',
        //     para: 'CrowdExotic is a platform that offers an innovative way to invest in luxury cars. It allows users to invest in high-end vehicles at wholesale prices and earn returns when these cars are sold.',
        //     imageSrc: "https://crowdexotic.com/images/headerlogo.png",
        //     url: ['https://crowdexotic.com/'],
        //     technology: "ReactJs,NextJs,NodeJs,ExpressJs"
        // },
        // {
        //     title: 'EasyCoach Club',
        //     para: 'This platform is designed to manage footballers, tracking their attendance records, league match performances, and injuries.',
        //     imageSrc: "https://easycoach.s3.eu-central-1.amazonaws.com/dev/dev-051222122821-622749494.jpeg",
        //     url: ['https://dev.easycoach.club/'],
        //     technology: "ReactJs"
        // }, 
        // {
        //     title: "Loopa The Garbage Collector", // Project Title - Add Your Project Title Here
        //     para: "Book Your Garbage Collector in Your Area.",
        //     // Add Your Service Type Here
        //     // Project Image - Add Your Project Image Here
        //     imageSrc: "https://i.ibb.co/WHPXQRM/Capture.png",
        //     // Project URL - Add Your Project Url Here
        //     url: ["https://loopa.p2gmanagement.xyz/"],
        //     technology: "ReactJs,MaterialUI"
        // }, {
        //     title: "ViewPure", // Project Title - Add Your Project Title Here
        //     para: "Watch Youtube Videos Without ADs.",
        //     // Add Your Service Type Here
        //     // Project Image - Add Your Project Image Here
        //     imageSrc: "https://i.ibb.co/c6G176t/screencapture-viewpure-2021-04-17-20-35-30.png",
        //     // Project URL - Add Your Project Url Here
        //     url: ["http://www.viewpure.com/"],
        //     technology: "ReactJs"
        // }, {
        //     title: "Behaviour World Application", // Project Title - Add Your Project Title Here
        //     para: "Simple Game for Special Kids.",
        //     // Add Your Service Type Here
        //     // Project Image - Add Your Project Image Here
        //     imageSrc: "https://i.ibb.co/zhKx8P3/Capture.png",
        //     // Project URL - Add Your Project Url Here
        //     url: ["https://www.mybehaviorbuddy.com/"],
        //     technology: "HTML,CSS,JAVASCRIPT"
        // }, {
        //     title: 'Virtual Tour Web Application',
        //     para: 'Complete Mern Stack Based Application',
        //     imageSrc: "http://3.108.146.184:8082/imgs/white-logo.svg",
        //     url: ['http://3.108.146.184:8082/'],
        //     technology: "ReactJs,NodeJs,MongoDB,Express"
        // }, {
        //     title: 'PantherScout Web App',
        //     para: 'Project Management & Product Reasearch Tools.',
        //     imageSrc: "",
        //     url: ['https://www.scoutpanther.com/'],
        //     technology: "ReactJs"
        // }, {
        //     title: 'Asian Story',
        //     para: 'Ecommerce Mern Stack Based Ecommerce Application.',
        //     imageSrc: "https://ibb.co/7SyksZn",
        //     url: ['https://ourasianstory.com/'],
        //     technology: "ReactJs,NodeJs,MongoDB,Express"
        // }
{
        title: 'VA Claims Academy',
        para: 'Educational platform helping veterans navigate and win disability claims through expert-led courses and coaching.',
        imageSrc: "https://i.ibb.co/W4XRrgYh/chrome-capture-2026-1-10-2.png",
        technology: "NextJs, React, AWS, Stripe, Supabase",
        url: ['https://www.vaclaims-academy.com/']
    },
    {
        title: 'Lobium AI Public Affairs',
        para: 'AI-powered SaaS platform that automates legislative analysis and stakeholder mapping for EU public affairs.',
        imageSrc: "https://i.ibb.co/mCdmsnDG/chrome-capture-2026-1-10-3.png",
        technology: "React, HTML, CSS, AWS",
        url: ['https://lobium.ai/']
    },
    {
        title: 'EasyCoach Sports Management',
        para: 'All-in-one platform for football clubs to manage coaching, player development, and performance analysis.',
        imageSrc: "https://i.ibb.co/23hYY89F/chrome-capture-2026-1-10-1.png",
        technology: "React, HTML, CSS, Stripe",
        url: [ 'https://dev.easycoach.club/app']
    },
    {
        title: 'MCRO TikTok Automation',
        para: 'SaaS tool to automate TikTok promotions, schedule flash sales, and manage affiliate reminders.',
        imageSrc: "https://i.ibb.co/QjN3bXHg/chrome-capture-2026-1-10-4.png",
        technology: "NextJs, React, AWS, Stripe, MongoDB",
        url: ['https://mcro.ai/']
    },
    {
        title: 'PetLuvs Care Marketplace',
        para: 'A comprehensive mobile ecosystem connecting pet owners with local vets, groomers, and pet products.',
        imageSrc: "https://i.ibb.co/WW8zFq1n/chrome-capture-2026-1-10-5.png",
        technology: "React Native, React, NodeJs, MongoDB, Stripe",
        url: ['https://petluvs.com/']
    },
    {
        title: 'AI HeftIQ Insights',
        para: 'An AI-driven analytics platform providing instant e-commerce insights through simple chat prompts.',
        imageSrc: "https://i.ibb.co/4Ztv6Bpy/chrome-capture-2026-1-10-6.png",
        technology: "NextJs, React, AWS, Tinybird, AI, LLM",
        url: ['https://ai-bc-dev.heftiq.com/']
    },
    {
        title: 'PinTV Live Display',
        para: 'A tri-screen system for live events featuring real-time scores, stats, and customizable virtual scoreboards.',
        imageSrc: "https://i.ibb.co/GX7YXwz/chrome-capture-2026-1-10-7.png",
        technology: "React, AWS, PostgreSQL, NodeJs",
        url: ['https://www.mypintv.com/']
    },
    {
        title: 'Defly Ball Blockchain Web App',
        para: 'A blockchain-based play-to-earn NFT racing game featuring collectible dogs and staking rewards.',
        imageSrc: "https://www.deflyball.com/assets/img/defly/logo.png",
        technology: "ReactJs, Solidity, Web3, DAPP",
        url: ['https://www.crunchbase.com/organization/deflyball']
    },
    {
        title: 'HyperLeague Metaverse',
        para: 'Blockchain AI-powered metaverse racing game featuring customizable avatars and hover vehicles.',
        imageSrc: "https://i.ibb.co/KzLNs3GN/chrome-capture-2026-1-11.png",
        technology: "React, Solidity, Web3, Blockchain",
        url: ['https://hyperleague.vercel.app/']
    }
        /*
    If You Want To Add More Project just Copy and Paste This At The End
    ,{
        title: 'Project Five',
        para: 'Something Amazing',
        imageSrc: "",
        url: ''
    }
    */
    ],
    blockchain: [
        {
            title: 'Defly Ball Blockchain Web App',
            para: 'Blockchain Project.',
            imageSrc: "https://www.deflyball.com/assets/img/defly/logo.png",
            technology: "ReactJs,Solidity,DAPP",
            url: ['https://www.deflyball.com/']
        }, {
            title: 'HyperLeague Blockchain Web App',
            para: 'Blockchain Project.',
            imageSrc: "https://ibb.co/Dg8GMSbG",
            technology: "NextJs,Solidity,DAPP",
            url: ['https://www.deflyball.com/', 'https://market.deflyball.com/']
        },
    ],

    // End Work Section -----------------------

    // About Secton --------------
aboutParaOne: "Hello! I’m Salman Hafeez, a Senior Software Engineer and UET Lahore graduate with over five years of professional experience in the tech industry. My expertise is rooted in the MERN Stack, where I specialize in architecting high-performance backend pipelines with Node.js and crafting fast, dynamic interfaces using Next.js and React.",
    aboutParaTwo: "I have a proven track record of driving complex data migrations, deploying autonomous multi-agent AI systems, and leading development engineering teams to success. My approach combines technical precision with deep problem-solving, ensuring every optimization delivers maximum speed and platform reliability.",
    aboutParaThree: "",
    aboutImage: "https://i.ibb.co/Z8hJWqq/Whats-App-Image-2021-05-15-at-8-48-45-PM.jpg",
    // End About Section ---------------------

    // Skills Section ---------------

    // Import Icons from the top and link it here

    skills: [
        {
            img: htmlIcon,
            para: "HTML/HTML5"
        },
        {
            img: cssIcon,
            para: "CSS/CSS3"
        },

        {
            img: bootstrapIcon,
            para: "BOOTSTRAP"
        },
        {
            img: jsIcon,
            para: "JAVASCRIPT"
        }, {
            img: reactIcon,
            para: "REACT/REACT NATIVE"
        }, {
            img: reduxIcon,
            para: "REDUX & MIDDLEWARE"
        }, {
            img: firebaseIcon,
            para: "FIREBASE"
        }, {
            img: sqlIcon,
            para: "SQL & SQLITE"
        }, {
            img: nodeIcon,
            para: "Node Js & Express.js"
        }, {
            img: mongoIcon,
            para: "MongoDB"
        }, {
            img: graphqlIcon,
            para: "GRAPHQL"
        }, {
            img: designIcon,
            para: "MOBILE & WEB DESIGN"
        },
        {
            img: nextjsIcon,
            para: "NEXT.JS"
        },
        {
            img: postgresIcon,
            para: "POSTGRESQL"
        },
        {
            img: redisIcon,
            para: "REDIS"
        },
        {
            img: openaiIcon,
            para: "OPENAI / GPT-4O"
        },
        {
            img: awsIcon,
            para: "AWS"
        },
        {
            img: gcpIcon,
            para: "GCP"
        },
        // {
        // img: codeIcon,
        // para:
        //     "",
        // },
    ],

    // import firebaseIcon from "./images/firebase.svg"
    // import sqlIcon from "./images/sql.svg"
    // import nodeIcon from "./images/node.svg"
    // import mongoIcon from "./images/mongodb.svg"
    // import graphqlIcon from "./images/graphql.svg"
    // import bootstrapIcon from "./images/bootstrap.svg"

    // End Skills Section --------------------------

    // Promotion Section --------------------------

    promotionHeading: "Heading",
    promotionPara: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    // End Promotion Section -----------------

    // Contact Section --------------

    contactSubHeading: "Let's create your next experience together",
    social: [
        // Add Or Remove The Link Accordingly
        {
            img: githubIcon,
            url: "https://github.com/SalluMaan"
        },
        {
            img: codepenIcon,
            url: "https://www.codepen.com/"
        },
        {
            img: dribbbleIcon,
            url: "https://www.linkedin.com/in/muhammad-salman-hafeez-247874139/"
        },
        {
            img: instagramIcon,
            url: "https://www.instagram.com/"
        }, {
            img: CVIcon,
            url: "https://flowcv.com/resume/j21wsitun6pf"
        },
    ],

    // End Contact Section ---------------
}

// Thanks for using this template, I would love to hear from you contact me at hello@chetanverma.com
// npm i gatsby prop-types react react-dom react-helmet react-reveal react-scroll node-sass gatsby-transformer-sharp gatsby-source-filesystem gatsby-plugin-sharp gatsby-plugin-smoothscroll gatsby-image gatsby-plugin-manifest gatsby-plugin-offline gatsby-plugin-react-helmet gatsby-plugin-sass
